import React, { ChangeEvent, ReactNode } from "react";
import "./index.scss";
import { convertToCapitalize } from "../../utils";

interface InputProps {
  label?: string | ReactNode;
  name: string;
  id: string;
  placeholder?: string;
  type?: string;
  labelClassName?: string;
  className?: string;
  error?: string;
  value: string | number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  customElement?: React.ReactNode;
  disabled?: boolean;
  [key: string]: any; // To allow additional props
}

const Input: React.FC<InputProps> = ({
  label,
  name,
  id = "",
  placeholder = "",
  type = "text",
  labelClassName,
  className = "",
  error = "",
  value,
  onChange,
  required = false,
  customElement = null,
  disabled = false,
  ...props
}) => {
  return (
    <div className={`form-control ${type}`}>
      {label ? (
        <label htmlFor={id} className={labelClassName}>
          {label}
          {required ? <span className="required">*</span> : null}
        </label>
      ) : null}
      <div className="relative">
        <input
          type={type}
          id={id}
          name={name}
          placeholder={convertToCapitalize(placeholder)}
          value={value}
          onChange={onChange}
          className={`${className} ${error?.length ? "error border-danger " : ""}`}
          disabled={disabled}
          onFocus={(e) =>
            e?.target?.addEventListener(
              "wheel",
              function (e) {
                e.preventDefault();
              },
              { passive: false }
            )
          }
          {...props}
        />
        {customElement}
      </div>
      {error?.length ? (
        <div className="text-danger error-message">{error}</div>
      ) : null}
    </div>
  );
};

export default Input;
